import React, { useEffect, useState, useContext } from "react";
import { TrafficContext } from "../../App";
import '../../universal.css';
import { orderedAirports } from '../../data/config';

const TAF = () => {
  const [tafs, setTafs] = useState([]);
  const [mode, setMode] = useState(() => {
    return localStorage.getItem('tafMode') || "SELECT";
  });
  const [selectedAirport, setSelectedAirport] = useState(() => {
    return localStorage.getItem('selectedAirport') || "EFHK";
  });
  const traffic = useContext(TrafficContext);

  useEffect(() => {
    const fetchTAFs = async () => {
      try {
        let icaoCodes = [];

        if (mode === "ALL") {
          icaoCodes = orderedAirports.map(airport => airport.icao);
        } else if (mode === "AUTO") {
          const icaoSet = new Set(
            traffic
              .map((pilot) => {
                const departure = pilot.flight_plan.departure;
                const arrival = pilot.flight_plan.arrival;
                return [departure, arrival];
              })
              .flat()
              .filter((icao) => icao.startsWith("EF"))
          );
          icaoCodes = Array.from(icaoSet);
        } else {
          icaoCodes = [selectedAirport];
        }

        const response = await fetch(`https://api.met.no/weatherapi/tafmetar/1.0/taf.xml?icao=${icaoCodes.join(',')}`);
        const xmlData = await response.text();

        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(xmlData, "application/xml");

        const tafNodes = xmlDoc.getElementsByTagName("metno:terminalAerodromeForecast");
        const tafs = Array.from(tafNodes).map(taf => ({
          code: taf.getElementsByTagName("metno:icaoAirportIdentifier")[0].textContent,
          issuedTime: taf.getElementsByTagName("gml:timePosition")[0].textContent,
          beginPosition: taf.getElementsByTagName("gml:beginPosition")[0].textContent,
          tafText: taf.getElementsByTagName("metno:tafText")[0].textContent
        }));

        // Filter the latest TAF based on beginPosition
        const latestTafs = tafs.reduce((acc, taf) => {
          if (!acc[taf.code] || new Date(taf.beginPosition) > new Date(acc[taf.code].beginPosition)) {
            acc[taf.code] = taf;
          }
          return acc;
        }, {});

        const filteredTafs = Object.values(latestTafs);
        setTafs(filteredTafs);
      } catch (error) {
        console.error("Error fetching TAFs:", error);
      }
    };

    if (mode !== "NONE") {
      fetchTAFs();
      const interval = setInterval(fetchTAFs, 60000);
      return () => clearInterval(interval);
    }
  }, [mode, selectedAirport, traffic]);

  useEffect(() => {
    localStorage.setItem('tafMode', mode);
  }, [mode]);

  useEffect(() => {
    localStorage.setItem('selectedAirport', selectedAirport);
  }, [selectedAirport]);

  const highlightTAF = (text) => {
    const icaoPattern = /(EF[A-Z]{2}\s)/g;
    const timePattern = /(\d{4}\/\d{4})/g;

    return text
      .replace(icaoPattern, '<span class="highlight">$1</span>')
      .replace(timePattern, '<span class="highlight">$1</span>');
  };

  return (
    <div className="bg-gray-300 text-white h-full">
      <div className="flex space-x-2 bg-gray-300 w-full text-xs">
        <button className={`p-1 ${mode === "AUTO" ? "bg-gray-600" : "bg-gray-400"}`} onClick={() => setMode("AUTO")}>
          AUTO
        </button>
        <button className={`p-1 ${mode === "ALL" ? "bg-gray-600" : "bg-gray-400"}`} onClick={() => setMode("ALL")}>
          ALL
        </button>
        <button className={`p-1 ${mode === "SELECT" ? "bg-gray-600" : "bg-gray-400"}`} onClick={() => setMode("SELECT")}>
          SELECT
        </button>
        <select
          className={`p-1 ${mode === "SELECT" ? "bg-gray-600" : "bg-gray-400"}`}
          onChange={(e) => setSelectedAirport(e.target.value)}
          value={selectedAirport}
          disabled={mode !== "SELECT"}
        >
          {orderedAirports.map((airport) => (
            <option key={airport.icao} value={airport.icao}>
              {airport.icao}
            </option>
          ))}
        </select>
      </div>
      <div className="overflow-y-auto text-black text-xs monospace-font mt-1 pb-8 h-full">
        {tafs.length === 0 ? (
          <p>No TAF data available</p>
        ) : (
          tafs.map((t) => (
            <p key={t.code} className="table-line p-1" dangerouslySetInnerHTML={{ __html: highlightTAF(t.tafText) }} />
          ))
        )}
      </div>
    </div>
  );
};

export default TAF;
